// product-tracker.js

class ProductTracker {
  constructor() {
    this.supabaseUrl = "https://penkozrfaxruujxpotdn.supabase.co";
    this.supabaseKey =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBlbmtvenJmYXhydXVqeHBvdGRuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM5NDIyNzYsImV4cCI6MjA2OTUxODI3Nn0.peEO1604jU2dxZD2ZQ1OYLUsxs8sNmK-7MIUQZ8E7Rw";
    this.maxItems = 6;
    this.customerId = window.myShopify?.customerId || null;
  
    if (typeof supabase === "undefined") {
      console.error("Product Tracker Error: Supabase client not loaded.");
      return;
    }
    this.sbClient = supabase.createClient(this.supabaseUrl, this.supabaseKey);
  }

  async track(productHandle) {
  
    if (!productHandle) {
     
      return;
    }
    if (!this.customerId) {
      // Guest: track in localStorage
      let handles = [];
      try {
        handles = JSON.parse(
          localStorage.getItem("recently_viewed_handles") || "[]"
        );
      } catch (e) {
        handles = [];
      }
      // Remove if already present
      handles = handles.filter((h) => h !== productHandle);
      // Add to front
      handles.unshift(productHandle);
      // Limit to maxItems
      handles = handles.slice(0, this.maxItems);
      localStorage.setItem("recently_viewed_handles", JSON.stringify(handles));
     
      return;
    }
    try {
      const upsertData = {
        customer_id: this.customerId,
        product_handle: productHandle,
        created_at: new Date().toISOString(),
      };
      const upsertResult = await this.sbClient
        .from("recently_viewed_items")
        .upsert(upsertData, { onConflict: "customer_id, product_handle" });
      const { data, error } = await this.sbClient
        .from("recently_viewed_items")
        .select("id, created_at")
        .eq("customer_id", this.customerId)
        .order("created_at", { ascending: false });
      if (error) throw error;
      if (data.length > this.maxItems) {
        const oldestItem = data[data.length - 1];
        const deleteResult = await this.sbClient
          .from("recently_viewed_items")
          .delete()
          .eq("id", oldestItem.id);
      
      }
    } catch (error) {
      console.error("Error tracking recently viewed item:", error);
    }
  }
}

// --- INITIALIZATION ---
document.addEventListener("DOMContentLoaded", () => {
  const tracker = new ProductTracker();
  // Only extract handle from URL, ignore product JSON script
  const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (match && match[1]) {
    const handle = match[1];
    tracker.track(handle);
  } else {
    console.warn("[ProductTracker] Could not extract product handle from URL.");
  }
});
